import { Cell } from '@table-library/react-table-library/table';
import moment from 'moment';
import ActionButtons from './actionButtons';

export const COLUMNS = (current_url, csrf_token, onOpenModal, t) => [
    {
        label: t('domain_runs_qa.columns.active_users'),
        key: 'user',
        data: 'user',
        Component: Cell,
        pinLeft: true,
        renderCell: ({ data, item, csvDownload }) => {
            if (csvDownload) return data;
            return (
                <div className="table-main">
                    <div className="d-flex align-items-center">
                        <button
                            onClick={() => onOpenModal(data, item.import_keywords)}
                            className="word-break user-names-btn"
                        >
                            <strong className="table-url-strong">
                                <div className="word-break">{data}</div>
                            </strong>
                        </button>
                        <a href={`/customers/login_as/${item.userId}`}>
                            <i className="icofont-login"></i>
                        </a>
                    </div>
                </div>
            );
        },
    },
    {
        label: t('domain_runs_qa.columns.domain'),
        key: 'domain',
        data: 'domain',
        Component: Cell,
        pinLeft: true,
        renderCell: ({ data, csvDownload, item }) => {
            if (csvDownload) return data;

            return (
                <div className="table-main">
                    <div className="d-flex align-items-center">
                        <a
                            target="_blank"
                            className="link-website d-inline-flex align-items-center justify-content-center m-0 mr-10"
                            href={`/halubcnd/docs/log/?q=${encodeURIComponent(data)}`}
                            rel="noreferrer"
                            title={t('domain_runs_qa.columns.open_logs')}
                        >
                            <i className="icon-external-link"></i>
                        </a>
                        <strong className="table-url-strong">
                            <a
                                href={`/domains/${item?.domain_id}/gsc-reports/`}
                                className="d-inline-flex align-items-cente"
                                rel="noreferrer"
                            >
                                {data}
                            </a>
                        </strong>
                    </div>
                    <div className="logs-buttons">
                        <a
                            href={`/halubcnd/docs/log/?q=${encodeURIComponent(data)}`}
                            target="_blank"
                            rel="noreferrer"
                        >
                            {t('domain_runs_qa.columns.logs')}
                        </a>
                        <a
                            href={`/halubcnd/docs/linkedaccountsgranterror/?q=${encodeURIComponent(
                                data,
                            )}`}
                            target="_blank"
                            rel="noreferrer"
                        >
                            {t('domain_runs_qa.columns.grants')}
                        </a>
                    </div>
                </div>
            );
        },
    },
    {
        label: t('domain_runs_qa.columns.discover_avg_daily_records'),
        key: 'DavgDailyRecords',
        data: 'DavgDailyRecords',
        Component: Cell,
    },
    {
        label: t('domain_runs_qa.columns.dcollection_days'),
        key: 'DcollectionDays',
        data: 'DcollectionDays',
        Component: Cell,
    },
    {
        label: t('domain_runs_qa.columns.dlast_collection'),
        key: 'DlastCollection',
        data: 'DlastCollection',
        Component: Cell,
        renderCell: ({ data }) => data?.value ?? null,
    },
    {
        label: t('domain_runs_qa.columns.dlast_date'),
        key: 'DlastDate',
        data: 'DlastDate',
        Component: Cell,
        renderCell: ({ data, csvDownload }) => {
            if (csvDownload) return data;
            if (!data?.value) return null;
            let date = new Date();
            date.setDate(date.getDate() - 3);
            const dateModified = moment(date).format('YYYY-MM-DD');
            const style = new Date(data?.value) < new Date(dateModified) ? { color: 'red' } : {};
            return <div style={style}>{data?.value}</div>;
        },
    },
    {
        label: t('domain_runs_qa.columns.dlast_records_collected'),
        key: 'DlastRecordsCollected',
        data: 'DlastRecordsCollected',
        Component: Cell,
    },
    {
        label: t('domain_runs_qa.columns.drecords'),
        key: 'Drecords',
        data: 'Drecords',
        Component: Cell,
    },
    {
        label: t('domain_runs_qa.columns.avg_weekly_records'),
        key: 'avgWeeklyRecords',
        data: 'avgWeeklyRecords',
        Component: Cell,
    },
    {
        label: t('domain_runs_qa.columns.collection_weeks'),
        key: 'collectionWeeks',
        data: 'collectionWeeks',
        Component: Cell,
    },
    {
        label: t('domain_runs_qa.columns.first_date'),
        key: 'firstDate',
        data: 'firstDate',
        Component: Cell,
        renderCell: ({ data }) => data?.value ?? null,
    },
    {
        label: t('domain_runs_qa.columns.last_collection'),
        key: 'lastCollection',
        data: 'lastCollection',
        Component: Cell,
        renderCell: ({ data }) => data?.value ?? null,
    },
    {
        label: t('domain_runs_qa.columns.last_date'),
        key: 'lastDate',
        data: 'lastDate',
        Component: Cell,
        renderCell: ({ data, csvDownload }) => {
            if (csvDownload) return data;
            if (!data?.value) return null;
            let date = new Date();
            date.setDate(date.getDate() - 8);
            const dateModified = moment(date).format('YYYY-MM-DD');
            const style = new Date(data?.value) < new Date(dateModified) ? { color: 'red' } : {};
            return <div style={style}>{data?.value}</div>;
        },
    },
    {
        label: t('domain_runs_qa.columns.last_records_collected'),
        key: 'lastRecordsCollected',
        data: 'lastRecordsCollected',
        Component: Cell,
    },
    {
        label: t('domain_runs_qa.columns.records'),
        key: 'records',
        data: 'records',
        Component: Cell,
    },
    {
        label: t('domain_runs_qa.columns.actions'),
        key: 'actions',
        data: 'actions',
        Component: Cell,
        renderCell: ({ item, csvDownload }) =>
            csvDownload ? null : (
                <ActionButtons
                    current_url={current_url}
                    csrf_token={csrf_token}
                    domain={item.domain}
                />
            ),
    },
];
